export default {
  // 도메인/보안서버 연결상태
  NECESSARY: '필요',
  CAUTION: '주의',
  COMPLETE: '완료',
};
